import Vue, { CreateElement } from '@src/vue'
import { Component } from 'vue-property-decorator'

import { Select } from '@src/elements/select/select'
import { OptionGroup } from '@src/elements/select/option-group'
import { Option } from '@src/elements/select/option'

export enum MemberCheckupsFilterType {
  COMPLETED = 'completed' ,
  PLANNED = 'planned',
  IN_PROGRESS = 'in_progress'
}

export const LIST_OF_FILTERS = [
  MemberCheckupsFilterType.COMPLETED, MemberCheckupsFilterType.PLANNED, MemberCheckupsFilterType.IN_PROGRESS
]

@Component({
  computed: {
    checkupFilters () {
      return this.$store.state.checkups.checkupFilters
    }
  }
})
export class CheckupsDeviceFilter extends Vue {

  private checkupFilters: string[]

  constructor () {
    super()
  }

  filter (value) {
    if (value === '') {
      this.$store.dispatch('filterCheckups', [])
      return
    }
    const filters = LIST_OF_FILTERS.filter((filterValue) => filterValue !== value)

    this.$store.dispatch('filterCheckups', filters)
  }

  render (h: CreateElement) {
    let typeFilterLabel = this.$t('PAGE.MEMBERS.ACTIVITIES.TYPES.ALL')
    if (this.checkupFilters.includes('planned') && this.checkupFilters.includes('in_progress')) {
      typeFilterLabel = this.$t('PAGE.MEMBERS.CHECKUPS.STATUS.COMPLETED')
    } else if (this.checkupFilters.includes('planned') && this.checkupFilters.includes('completed')) {
      typeFilterLabel = this.$t('PAGE.MEMBERS.CHECKUPS.STATUS.IN_PROGRESS')
    } else if (this.checkupFilters.includes('completed') && this.checkupFilters.includes('in_progress')) {
      typeFilterLabel = this.$t('PAGE.MEMBERS.CHECKUPS.STATUS.PLANNED')
    }

    return <div id='checkups-device-filter-wrapper'>
      <Select filter={true} ref='statusFilter' cssClass='status-types' value={typeFilterLabel} label={this.$t('PAGE.MEMBERS.ACTIVITIES.STATUS.STATUS')}>
        <OptionGroup>
          <Option type='single-option' value={''} select={this.filter}
                  label={this.$t('PAGE.MEMBERS.ACTIVITIES.TYPES.ALL')}/>
          <Option type='single-option' value={MemberCheckupsFilterType.COMPLETED} select={this.filter}
                  label={this.$t('PAGE.MEMBERS.CHECKUPS.STATUS.COMPLETED')}/>
          <Option type='single-option' value={MemberCheckupsFilterType.PLANNED} select={this.filter}
                  label={this.$t('PAGE.MEMBERS.CHECKUPS.STATUS.PLANNED')}/>
          <Option type='single-option' value={MemberCheckupsFilterType.IN_PROGRESS} select={this.filter}
                  label={this.$t('PAGE.MEMBERS.CHECKUPS.STATUS.IN_PROGRESS')}/>
        </OptionGroup>
      </Select>
    </div>
  }
}
